import { RenderLayoutError } from "../errors";
import type { RenderContext } from "../types/render";
import type { CompiledTemplate, LayoutResult } from "../types/template";
import type { Rect } from "./anchorPlacement";
import { layoutContainer } from "./flowLayout";

export function layoutTemplate(
  compiled: CompiledTemplate,
  valuesByElementId: Map<string, string>,
  hiddenElementIds: Set<string>,
  ctx: RenderContext,
): LayoutResult {
  const canvasPadding = compiled.canvas.paddingMm;
  const drawable: Rect = {
    x: canvasPadding.left,
    y: canvasPadding.top,
    width: compiled.canvas.widthMm - canvasPadding.left - canvasPadding.right,
    height: compiled.canvas.heightMm - canvasPadding.top - canvasPadding.bottom,
  };

  if (drawable.width <= 0 || drawable.height <= 0) {
    throw new RenderLayoutError("Canvas padding leaves no drawable area.");
  }

  const elements = [] as LayoutResult["elements"];
  const diagnostics = [] as LayoutResult["diagnostics"];

  for (const container of compiled.containers) {
    const laidOut = layoutContainer(
      container,
      drawable,
      valuesByElementId,
      hiddenElementIds,
      ctx,
    );
    elements.push(...laidOut.elements);
    diagnostics.push(...laidOut.diagnostics);
  }

  return {
    canvasWidthMm: compiled.canvas.widthMm,
    canvasHeightMm: compiled.canvas.heightMm,
    elements,
    diagnostics,
  };
}
